import { Lightbulb } from 'lucide-react'

import { Button } from '~/components/ui/button.tsx'
import {
	Popover,
	PopoverContent,
	PopoverTrigger,
} from '~/components/ui/popover.tsx'

export function TooltipPopover({
	title,
	content,
}: {
	title: string
	content: string
}) {
	return (
		<Popover>
			<PopoverTrigger asChild>
				<Button
					variant="outline"
					className="h-8 w-8 rounded-full p-0 lg:h-6 lg:w-6"
				>
					<Lightbulb className="h-4 w-4" />
					<span className="sr-only">Open popover</span>
				</Button>
			</PopoverTrigger>
			<PopoverContent className="bg-opacity-85 max-w-[400px] bg-white">
				<div className="grid gap-4">
					<div className="space-y-2">
						<h4 className="font-medium leading-none">{title}</h4>
						<p className="text-sm text-muted-foreground">{content}</p>
					</div>
				</div>
			</PopoverContent>
		</Popover>
	)
}
